import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildViewUIElementEvent = (inputProperties, currentPage) => ({
    ...inputProperties,
    object: Promise.all([inputProperties.object, currentPage]).then(([objectProperties, page]) => ({
        page,
        ...objectProperties,
        navigationType: getNavigationType(),
        type: 'UIElement',
        url: window.location.href,
    })),
});
//# sourceMappingURL=event-builder.js.map